"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectTypes = exports.isProjectType = exports.projectTypeMapper = exports.MarineProjectType = exports.RestorationProjectType = exports.CarbonRemovalProjectType = exports.CarbonAvoidanceProjectType = exports.ReforestationProjectType = void 0;
const projects_1 = require("./projects");
var ReforestationProjectType;
(function (ReforestationProjectType) {
    ReforestationProjectType["All"] = "all_reforestation";
    ReforestationProjectType["Reforestation"] = "reforestation";
    ReforestationProjectType["None"] = "no_reforestation";
})(ReforestationProjectType = exports.ReforestationProjectType || (exports.ReforestationProjectType = {}));
var CarbonAvoidanceProjectType;
(function (CarbonAvoidanceProjectType) {
    CarbonAvoidanceProjectType["All"] = "all_avoidance";
    CarbonAvoidanceProjectType["Forestry"] = "forestry";
    CarbonAvoidanceProjectType["Capture"] = "capture";
    CarbonAvoidanceProjectType["Wetlands"] = "wetlands";
    CarbonAvoidanceProjectType["Renewables"] = "renewables";
    CarbonAvoidanceProjectType["Community"] = "community";
    CarbonAvoidanceProjectType["Transport"] = "transport";
    CarbonAvoidanceProjectType["Geothermal"] = "geothermal";
    CarbonAvoidanceProjectType["None"] = "no_avoidance";
})(CarbonAvoidanceProjectType = exports.CarbonAvoidanceProjectType || (exports.CarbonAvoidanceProjectType = {}));
var CarbonRemovalProjectType;
(function (CarbonRemovalProjectType) {
    CarbonRemovalProjectType["All"] = "all_removal";
    CarbonRemovalProjectType["AfforestationReforestationAndRevegetation"] = "afforestation_reforestation_and_revegetation";
    CarbonRemovalProjectType["Biochar"] = "biochar";
    CarbonRemovalProjectType["BlueCarbon"] = "blue_carbon";
    CarbonRemovalProjectType["DirectAirCapture"] = "direct_air_capture";
    CarbonRemovalProjectType["None"] = "no_removal";
})(CarbonRemovalProjectType = exports.CarbonRemovalProjectType || (exports.CarbonRemovalProjectType = {}));
var RestorationProjectType;
(function (RestorationProjectType) {
    RestorationProjectType["All"] = "all_terrestrial";
    RestorationProjectType["Wildflowers"] = "wildflowers";
    RestorationProjectType["Rainforest"] = "rainforest_conservation_and_protection";
    RestorationProjectType["Wetlands"] = "wetlands";
    RestorationProjectType["Wildlife"] = "wildlife";
    RestorationProjectType["None"] = "no_restoration";
})(RestorationProjectType = exports.RestorationProjectType || (exports.RestorationProjectType = {}));
var MarineProjectType;
(function (MarineProjectType) {
    MarineProjectType["All"] = "all_marine";
    MarineProjectType["Seagrass"] = "seagrass";
    MarineProjectType["Kelp"] = "kelp_conservation";
    MarineProjectType["ProtectedAreas"] = "protected_areas";
    MarineProjectType["None"] = "no_marine";
})(MarineProjectType = exports.MarineProjectType || (exports.MarineProjectType = {}));
exports.projectTypeMapper = {
    [projects_1.ProjectSelector.All]: {
        title: 'All',
        tag: projects_1.ProjectSelector.All,
    },
    [projects_1.ProjectSelector.None]: {
        title: 'None',
        tag: projects_1.ProjectSelector.None,
    },
    [ReforestationProjectType.All]: {
        title: 'All',
        tag: ReforestationProjectType.All,
    },
    [ReforestationProjectType.None]: {
        title: 'None',
        tag: ReforestationProjectType.None,
    },
    [ReforestationProjectType.Reforestation]: {
        title: 'Native tree planting',
        tag: ReforestationProjectType.Reforestation,
    },
    [CarbonAvoidanceProjectType.None]: {
        title: 'None',
        tag: CarbonAvoidanceProjectType.None,
    },
    [CarbonAvoidanceProjectType.All]: {
        title: 'Carbon avoidance projects',
        tag: CarbonAvoidanceProjectType.All,
    },
    [CarbonAvoidanceProjectType.Forestry]: {
        title: 'Deforestation prevention',
        tag: CarbonAvoidanceProjectType.Forestry,
    },
    [CarbonAvoidanceProjectType.Capture]: {
        title: 'Greenhouse gas capture',
        tag: CarbonAvoidanceProjectType.Capture,
    },
    [CarbonAvoidanceProjectType.Wetlands]: {
        title: 'Wetland restoration',
        tag: CarbonAvoidanceProjectType.Wetlands,
    },
    [CarbonAvoidanceProjectType.Renewables]: {
        title: 'Renewable energy',
        tag: CarbonAvoidanceProjectType.Renewables,
    },
    [CarbonAvoidanceProjectType.Community]: {
        title: 'Community based',
        tag: CarbonAvoidanceProjectType.Community,
    },
    [CarbonAvoidanceProjectType.Transport]: {
        title: 'Efficient transportation',
        tag: CarbonAvoidanceProjectType.Transport,
    },
    [CarbonAvoidanceProjectType.Geothermal]: {
        title: 'Geothermal',
        tag: CarbonAvoidanceProjectType.Geothermal,
    },
    [CarbonRemovalProjectType.None]: {
        title: 'None',
        tag: CarbonRemovalProjectType.None,
    },
    [CarbonRemovalProjectType.All]: {
        title: 'Carbon removal projects',
        tag: CarbonRemovalProjectType.All,
    },
    [CarbonRemovalProjectType.AfforestationReforestationAndRevegetation]: {
        title: 'ARR',
        tag: CarbonRemovalProjectType.AfforestationReforestationAndRevegetation,
    },
    [CarbonRemovalProjectType.Biochar]: {
        title: 'Biochar',
        tag: CarbonRemovalProjectType.Biochar,
    },
    [CarbonRemovalProjectType.BlueCarbon]: {
        title: 'Blue carbon',
        tag: CarbonRemovalProjectType.BlueCarbon,
    },
    [CarbonRemovalProjectType.DirectAirCapture]: {
        title: 'Direct air capture',
        tag: CarbonRemovalProjectType.DirectAirCapture,
    },
    [RestorationProjectType.All]: {
        title: 'Terrestrial conservation/restoration projects',
        tag: RestorationProjectType.All,
    },
    [RestorationProjectType.None]: {
        title: 'None',
        tag: RestorationProjectType.None,
    },
    [RestorationProjectType.Rainforest]: {
        title: 'Rainforest conservation and protection',
        tag: RestorationProjectType.Rainforest,
    },
    [RestorationProjectType.Wetlands]: {
        title: 'Wetland restoration',
        tag: RestorationProjectType.Wetlands,
    },
    [RestorationProjectType.Wildlife]: {
        title: 'Wildlife',
        tag: RestorationProjectType.Wildlife,
    },
    [RestorationProjectType.Wildflowers]: {
        title: 'Wildflowers',
        tag: RestorationProjectType.Wildflowers,
    },
    [MarineProjectType.All]: {
        title: 'Marine projects',
        tag: MarineProjectType.All,
    },
    [MarineProjectType.None]: {
        title: 'None',
        tag: MarineProjectType.None,
    },
    [MarineProjectType.Seagrass]: {
        title: 'Seagrass',
        tag: MarineProjectType.Seagrass,
    },
    [MarineProjectType.Kelp]: {
        title: 'Kelp conservation',
        tag: MarineProjectType.Kelp,
    },
    [MarineProjectType.ProtectedAreas]: {
        title: 'Protected areas',
        tag: MarineProjectType.ProtectedAreas,
    },
};
function isProjectType(projectType, ...tags) {
    return tags.includes(projectType);
}
exports.isProjectType = isProjectType;
exports.ProjectTypes = Object.values(exports.projectTypeMapper);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdC10eXBlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wcm9qZWN0cy9wcm9qZWN0LXR5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHlDQUE0RDtBQVc1RCxJQUFZLHdCQUlYO0FBSkQsV0FBWSx3QkFBd0I7SUFDbEMscURBQXlCLENBQUE7SUFDekIsMkRBQStCLENBQUE7SUFDL0IscURBQXlCLENBQUE7QUFDM0IsQ0FBQyxFQUpXLHdCQUF3QixHQUF4QixnQ0FBd0IsS0FBeEIsZ0NBQXdCLFFBSW5DO0FBRUQsSUFBWSwwQkFVWDtBQVZELFdBQVksMEJBQTBCO0lBQ3BDLG1EQUFxQixDQUFBO0lBQ3JCLG1EQUFxQixDQUFBO0lBQ3JCLGlEQUFtQixDQUFBO0lBQ25CLG1EQUFxQixDQUFBO0lBQ3JCLHVEQUF5QixDQUFBO0lBQ3pCLHFEQUF1QixDQUFBO0lBQ3ZCLHFEQUF1QixDQUFBO0lBQ3ZCLHVEQUF5QixDQUFBO0lBQ3pCLG1EQUFxQixDQUFBO0FBQ3ZCLENBQUMsRUFWVywwQkFBMEIsR0FBMUIsa0NBQTBCLEtBQTFCLGtDQUEwQixRQVVyQztBQUVELElBQVksd0JBT1g7QUFQRCxXQUFZLHdCQUF3QjtJQUNsQywrQ0FBbUIsQ0FBQTtJQUNuQixzSEFBMEYsQ0FBQTtJQUMxRiwrQ0FBbUIsQ0FBQTtJQUNuQixzREFBMEIsQ0FBQTtJQUMxQixtRUFBdUMsQ0FBQTtJQUN2QywrQ0FBbUIsQ0FBQTtBQUNyQixDQUFDLEVBUFcsd0JBQXdCLEdBQXhCLGdDQUF3QixLQUF4QixnQ0FBd0IsUUFPbkM7QUFFRCxJQUFZLHNCQU9YO0FBUEQsV0FBWSxzQkFBc0I7SUFDaEMsaURBQXVCLENBQUE7SUFDdkIscURBQTJCLENBQUE7SUFDM0IsK0VBQXFELENBQUE7SUFDckQsK0NBQXFCLENBQUE7SUFDckIsK0NBQXFCLENBQUE7SUFDckIsaURBQXVCLENBQUE7QUFDekIsQ0FBQyxFQVBXLHNCQUFzQixHQUF0Qiw4QkFBc0IsS0FBdEIsOEJBQXNCLFFBT2pDO0FBRUQsSUFBWSxpQkFNWDtBQU5ELFdBQVksaUJBQWlCO0lBQzNCLHVDQUFrQixDQUFBO0lBQ2xCLDBDQUFxQixDQUFBO0lBQ3JCLCtDQUEwQixDQUFBO0lBQzFCLHVEQUFrQyxDQUFBO0lBQ2xDLHVDQUFrQixDQUFBO0FBQ3BCLENBQUMsRUFOVyxpQkFBaUIsR0FBakIseUJBQWlCLEtBQWpCLHlCQUFpQixRQU01QjtBQUVZLFFBQUEsaUJBQWlCLEdBQStCO0lBQzNELENBQUMsMEJBQWUsQ0FBQyxHQUFHLENBQUMsRUFBRTtRQUNyQixLQUFLLEVBQUUsS0FBSztRQUNaLEdBQUcsRUFBRSwwQkFBZSxDQUFDLEdBQUc7S0FDekI7SUFDRCxDQUFDLDBCQUFlLENBQUMsSUFBSSxDQUFDLEVBQUU7UUFDdEIsS0FBSyxFQUFFLE1BQU07UUFDYixHQUFHLEVBQUUsMEJBQWUsQ0FBQyxJQUFJO0tBQzFCO0lBQ0QsQ0FBQyx3QkFBd0IsQ0FBQyxHQUFHLENBQUMsRUFBRTtRQUM5QixLQUFLLEVBQUUsS0FBSztRQUNaLEdBQUcsRUFBRSx3QkFBd0IsQ0FBQyxHQUFHO0tBQ2xDO0lBQ0QsQ0FBQyx3QkFBd0IsQ0FBQyxJQUFJLENBQUMsRUFBRTtRQUMvQixLQUFLLEVBQUUsTUFBTTtRQUNiLEdBQUcsRUFBRSx3QkFBd0IsQ0FBQyxJQUFJO0tBQ25DO0lBQ0QsQ0FBQyx3QkFBd0IsQ0FBQyxhQUFhLENBQUMsRUFBRTtRQUN4QyxLQUFLLEVBQUUsc0JBQXNCO1FBQzdCLEdBQUcsRUFBRSx3QkFBd0IsQ0FBQyxhQUFhO0tBQzVDO0lBQ0QsQ0FBQywwQkFBMEIsQ0FBQyxJQUFJLENBQUMsRUFBRTtRQUNqQyxLQUFLLEVBQUUsTUFBTTtRQUNiLEdBQUcsRUFBRSwwQkFBMEIsQ0FBQyxJQUFJO0tBQ3JDO0lBQ0QsQ0FBQywwQkFBMEIsQ0FBQyxHQUFHLENBQUMsRUFBRTtRQUNoQyxLQUFLLEVBQUUsMkJBQTJCO1FBQ2xDLEdBQUcsRUFBRSwwQkFBMEIsQ0FBQyxHQUFHO0tBQ3BDO0lBQ0QsQ0FBQywwQkFBMEIsQ0FBQyxRQUFRLENBQUMsRUFBRTtRQUNyQyxLQUFLLEVBQUUsMEJBQTBCO1FBQ2pDLEdBQUcsRUFBRSwwQkFBMEIsQ0FBQyxRQUFRO0tBQ3pDO0lBQ0QsQ0FBQywwQkFBMEIsQ0FBQyxPQUFPLENBQUMsRUFBRTtRQUNwQyxLQUFLLEVBQUUsd0JBQXdCO1FBQy9CLEdBQUcsRUFBRSwwQkFBMEIsQ0FBQyxPQUFPO0tBQ3hDO0lBQ0QsQ0FBQywwQkFBMEIsQ0FBQyxRQUFRLENBQUMsRUFBRTtRQUNyQyxLQUFLLEVBQUUscUJBQXFCO1FBQzVCLEdBQUcsRUFBRSwwQkFBMEIsQ0FBQyxRQUFRO0tBQ3pDO0lBQ0QsQ0FBQywwQkFBMEIsQ0FBQyxVQUFVLENBQUMsRUFBRTtRQUN2QyxLQUFLLEVBQUUsa0JBQWtCO1FBQ3pCLEdBQUcsRUFBRSwwQkFBMEIsQ0FBQyxVQUFVO0tBQzNDO0lBQ0QsQ0FBQywwQkFBMEIsQ0FBQyxTQUFTLENBQUMsRUFBRTtRQUN0QyxLQUFLLEVBQUUsaUJBQWlCO1FBQ3hCLEdBQUcsRUFBRSwwQkFBMEIsQ0FBQyxTQUFTO0tBQzFDO0lBQ0QsQ0FBQywwQkFBMEIsQ0FBQyxTQUFTLENBQUMsRUFBRTtRQUN0QyxLQUFLLEVBQUUsMEJBQTBCO1FBQ2pDLEdBQUcsRUFBRSwwQkFBMEIsQ0FBQyxTQUFTO0tBQzFDO0lBQ0QsQ0FBQywwQkFBMEIsQ0FBQyxVQUFVLENBQUMsRUFBRTtRQUN2QyxLQUFLLEVBQUUsWUFBWTtRQUNuQixHQUFHLEVBQUUsMEJBQTBCLENBQUMsVUFBVTtLQUMzQztJQUNELENBQUMsd0JBQXdCLENBQUMsSUFBSSxDQUFDLEVBQUU7UUFDL0IsS0FBSyxFQUFFLE1BQU07UUFDYixHQUFHLEVBQUUsd0JBQXdCLENBQUMsSUFBSTtLQUNuQztJQUNELENBQUMsd0JBQXdCLENBQUMsR0FBRyxDQUFDLEVBQUU7UUFDOUIsS0FBSyxFQUFFLHlCQUF5QjtRQUNoQyxHQUFHLEVBQUUsd0JBQXdCLENBQUMsR0FBRztLQUNsQztJQUNELENBQUMsd0JBQXdCLENBQUMseUNBQXlDLENBQUMsRUFBRTtRQUNwRSxLQUFLLEVBQUUsS0FBSztRQUNaLEdBQUcsRUFBRSx3QkFBd0IsQ0FBQyx5Q0FBeUM7S0FDeEU7SUFDRCxDQUFDLHdCQUF3QixDQUFDLE9BQU8sQ0FBQyxFQUFFO1FBQ2xDLEtBQUssRUFBRSxTQUFTO1FBQ2hCLEdBQUcsRUFBRSx3QkFBd0IsQ0FBQyxPQUFPO0tBQ3RDO0lBQ0QsQ0FBQyx3QkFBd0IsQ0FBQyxVQUFVLENBQUMsRUFBRTtRQUNyQyxLQUFLLEVBQUUsYUFBYTtRQUNwQixHQUFHLEVBQUUsd0JBQXdCLENBQUMsVUFBVTtLQUN6QztJQUNELENBQUMsd0JBQXdCLENBQUMsZ0JBQWdCLENBQUMsRUFBRTtRQUMzQyxLQUFLLEVBQUUsb0JBQW9CO1FBQzNCLEdBQUcsRUFBRSx3QkFBd0IsQ0FBQyxnQkFBZ0I7S0FDL0M7SUFDRCxDQUFDLHNCQUFzQixDQUFDLEdBQUcsQ0FBQyxFQUFFO1FBQzVCLEtBQUssRUFBRSwrQ0FBK0M7UUFDdEQsR0FBRyxFQUFFLHNCQUFzQixDQUFDLEdBQUc7S0FDaEM7SUFDRCxDQUFDLHNCQUFzQixDQUFDLElBQUksQ0FBQyxFQUFFO1FBQzdCLEtBQUssRUFBRSxNQUFNO1FBQ2IsR0FBRyxFQUFFLHNCQUFzQixDQUFDLElBQUk7S0FDakM7SUFDRCxDQUFDLHNCQUFzQixDQUFDLFVBQVUsQ0FBQyxFQUFFO1FBQ25DLEtBQUssRUFBRSx3Q0FBd0M7UUFDL0MsR0FBRyxFQUFFLHNCQUFzQixDQUFDLFVBQVU7S0FDdkM7SUFDRCxDQUFDLHNCQUFzQixDQUFDLFFBQVEsQ0FBQyxFQUFFO1FBQ2pDLEtBQUssRUFBRSxxQkFBcUI7UUFDNUIsR0FBRyxFQUFFLHNCQUFzQixDQUFDLFFBQVE7S0FDckM7SUFDRCxDQUFDLHNCQUFzQixDQUFDLFFBQVEsQ0FBQyxFQUFFO1FBQ2pDLEtBQUssRUFBRSxVQUFVO1FBQ2pCLEdBQUcsRUFBRSxzQkFBc0IsQ0FBQyxRQUFRO0tBQ3JDO0lBQ0QsQ0FBQyxzQkFBc0IsQ0FBQyxXQUFXLENBQUMsRUFBRTtRQUNwQyxLQUFLLEVBQUUsYUFBYTtRQUNwQixHQUFHLEVBQUUsc0JBQXNCLENBQUMsV0FBVztLQUN4QztJQUNELENBQUMsaUJBQWlCLENBQUMsR0FBRyxDQUFDLEVBQUU7UUFDdkIsS0FBSyxFQUFFLGlCQUFpQjtRQUN4QixHQUFHLEVBQUUsaUJBQWlCLENBQUMsR0FBRztLQUMzQjtJQUNELENBQUMsaUJBQWlCLENBQUMsSUFBSSxDQUFDLEVBQUU7UUFDeEIsS0FBSyxFQUFFLE1BQU07UUFDYixHQUFHLEVBQUUsaUJBQWlCLENBQUMsSUFBSTtLQUM1QjtJQUNELENBQUMsaUJBQWlCLENBQUMsUUFBUSxDQUFDLEVBQUU7UUFDNUIsS0FBSyxFQUFFLFVBQVU7UUFDakIsR0FBRyxFQUFFLGlCQUFpQixDQUFDLFFBQVE7S0FDaEM7SUFDRCxDQUFDLGlCQUFpQixDQUFDLElBQUksQ0FBQyxFQUFFO1FBQ3hCLEtBQUssRUFBRSxtQkFBbUI7UUFDMUIsR0FBRyxFQUFFLGlCQUFpQixDQUFDLElBQUk7S0FDNUI7SUFDRCxDQUFDLGlCQUFpQixDQUFDLGNBQWMsQ0FBQyxFQUFFO1FBQ2xDLEtBQUssRUFBRSxpQkFBaUI7UUFDeEIsR0FBRyxFQUFFLGlCQUFpQixDQUFDLGNBQWM7S0FDdEM7Q0FDRixDQUFDO0FBS0YsU0FBZ0IsYUFBYSxDQUMzQixXQUF3QixFQUN4QixHQUFHLElBQU87SUFFVixPQUFPLElBQUksQ0FBQyxRQUFRLENBQUMsV0FBVyxDQUFDLENBQUM7QUFDcEMsQ0FBQztBQUxELHNDQUtDO0FBRVksUUFBQSxZQUFZLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyx5QkFBaUIsQ0FBQyxDQUFDIn0=